import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import Select from 'react-select';
import { connect } from 'react-redux';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import * as actions from '../action';
import * as c from '../constant';

function PdfContainer({
  getList,
  updatePdf,
  // item,
  setFormData,
  formData,
  createRichTextEditor,
  createInput,
  htmlToDraft,
  draftToHtml,
  convertToRaw
}) {

  const [form, setForm] = useState({
    type: 'PUV',
  })

  useEffect(() => {
    getList({ type: 'PUV' }, dataSelected => {
      setFormData(
        {
          text_color: _.get(dataSelected, 'data.0.attributes.text_color'),
          fill_color: _.get(dataSelected, 'data.0.attributes.fill_color'),
          header_text_color: _.get(dataSelected, 'data.0.attributes.header_text_color'),
          border_color: _.get(dataSelected, 'data.0.attributes.border_color'),
          ordinance_paragraph: htmlToDraft(_.get(dataSelected, 'data.0.attributes.ordinance_paragraph')),
        })
    });
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const newPayload = {
      type: form.type,
      ...formData,
      ordinance_paragraph: draftToHtml(convertToRaw(_.get(formData, 'ordinance_paragraph').getCurrentContent())),
    };

    return updatePdf(newPayload, () => {
      getList({
        type: form.type
      });
    });

  };

  const handleSelectChange = key => e => {
    setForm({
      ...form,
      [key]: e ? e.value : '',
    });
    getList({ type: e.value }, dataSelected => {
      setFormData(
        {
          text_color: _.get(dataSelected, 'data.0.attributes.text_color'),
          fill_color: _.get(dataSelected, 'data.0.attributes.fill_color'),
          header_text_color: _.get(dataSelected, 'data.0.attributes.header_text_color'),
          border_color: _.get(dataSelected, 'data.0.attributes.border_color'),
          ordinance_paragraph: htmlToDraft(_.get(dataSelected, 'data.0.attributes.ordinance_paragraph')),
        })
    });
  };

  return (
    <>
      <form onSubmit={handleOnSubmit}>
        <div className="card special-permit-tagging">
          <div className="card-content-listing">
            <div className="container-fluid p-10">
              <div className="row">
                <span className='font-weight-bold'>
                  PDF Settings
                </span>
              </div>
              <div className="row d-flex align-items-center mt-3">
                <div className="col-6">
                  <label className="label-reports font-weight-bold">Type</label>
                  <Select
                    placeholder="Select Type"
                    value={
                      c.TYPES.find(
                        typeSelected =>
                          _.get(form, 'type') ===
                          _.get(typeSelected, 'value')
                      ) || ''
                    }
                    onChange={handleSelectChange('type')}
                    options={c.TYPES}
                  />
                </div>
                <div className="row mt-1">
                  <div className="col-12 d-flex group-cms-color mb-0 mt-2 py-2">
                    <div className="col-6">
                      {createInput(
                        { key: 'text_color', label: 'Text Color' },
                        { required: true, type: 'color' },
                        'pdf-color'
                      )}
                    </div>
                    <div className="col-6">
                      {createInput(
                        { key: 'fill_color', label: 'Fill Color' },
                        { required: true, type: 'color' },
                        'pdf-color'
                      )}
                    </div>
                  </div>
                  <div className="col-12 d-flex group-cms-color mb-0 mt-2 py-2">
                    <div className="col-6">
                      {createInput(
                        { key: 'header_text_color', label: 'Header Text Color' },
                        { type: 'color' },
                        'pdf-color'
                      )}
                    </div>
                    <div className="col-6">
                      {createInput(
                        { key: 'border_color', label: 'Border Color' },
                        { type: 'color' },
                        'pdf-color'
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12 mt-5">
                  <div className="row">
                    <div className="col-12 form-group group-cms-color">
                      {createRichTextEditor(
                        { key: 'ordinance_paragraph', label: 'Ordinance Paragraph' },
                        { required: true, wrapperClassName: 'border' }
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-12 d-flex justify-content-center mt-5'>
                <button
                  type='submit'
                  className='btn button-submit-cms'
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

PdfContainer.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  // item: PropTypes.instanceOf(Array).isRequired,
  updatePdf: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  htmlToDraft: PropTypes.instanceOf(Function).isRequired,
  draftToHtml: PropTypes.instanceOf(Function).isRequired,
  convertToRaw: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: _.get(api, `COMPONENTS/get_list.list`) || []
});

const enhance = _.flowRight([
  withCmsForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(PdfContainer);
